export default __webpack_public_path__ + "static/media/1996.d9eee18a.png";